import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import TextView from "./TextView";
import { BuildContext } from "../classes/BuildContext";

export interface FeatureDetailsViewProps extends BaseUIProps {
  key?: string;
  info: string;
}

class _FeatureDetailsViewState extends ObservableComponent<FeatureDetailsViewProps> {
  static defaultProps = { info: "" };
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: FeatureDetailsViewProps) {
    super(props);

    this.initState();
  }
  public get info(): string {
    return this.props.info;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["info"], this.rebuild);
  }
  public componentDidUpdate(prevProps: FeatureDetailsViewProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.info !== this.props.info) {
      this.fire("info", this);
    }
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Column({
      mainAxisSize: ui.MainAxisSize.min,
      crossAxisAlignment: ui.CrossAxisAlignment.start,
      children: [
        TextView({
          data: this.info,
          style: new ui.TextStyle({ fontSize: 14 }),
          className: "x9d hc",
          key: "0",
        }),
      ],
      className: ui.join(this.props.className, "FeatureDetailsView xc9 hc vc"),
      ...copyBaseUIProps(this.props),
    });
  }
}
export default function FeatureDetailsView(props: FeatureDetailsViewProps) {
  return React.createElement(_FeatureDetailsViewState, {
    ..._FeatureDetailsViewState.defaultProps,
    ...props,
  });
}
